import { Component, SecurityContext } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { DsButtonVariants, DsModalService, Icons, IconStyles } from '@levelaccess/design-system';

import { SharedDateUtility } from '../../../../../../shared/utils/date.utility';

export interface AmpApiKeyModalContext {
  key: string;
  keyName: string;
  expiry: string;
}

@Component({
  selector: 'app-amp-api-key-modal',
  templateUrl: './amp-api-key-modal.component.html',
  styleUrls: ['./amp-api-key-modal-component.scss'],
  standalone: false,
})
export class AmpApiKeyModalComponent {
  public readonly Icons: typeof Icons = Icons;
  public readonly IconStyles: typeof IconStyles = IconStyles;
  public readonly SecurityContext: typeof SecurityContext = SecurityContext;
  public readonly DsButtonVariants: typeof DsButtonVariants = DsButtonVariants;

  public key: string;
  public keyName: string;
  public expiry: string;
  public downloadUrl: string;
  public downloadFileName: string;

  public displayWarning: boolean = true;

  public constructor(
    public modal: NgbActiveModal,
    private dsModalService: DsModalService,
  ) {}

  public init(context: AmpApiKeyModalContext): void {
    this.key = context.key;
    this.keyName = context.keyName;
    this.expiry = SharedDateUtility.getDateAtTime(new Date(context.expiry));
    this.downloadUrl = `data:text/plain;charset=utf-8,${this.key}`;
    this.downloadFileName = `${this.keyName}.txt`;
  }

  public closeWarning(): void {
    this.displayWarning = false;
  }

  public closeModal(): void {
    this.dsModalService.closeCurrentModal();
  }
}
